import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    await authService.waitForAuthInit();
    if (authService.isAuthenticated()) {
      return true;
    }
  } catch (e) {
    // fall through
  }

  router.navigate(['/auth/login']);
  return false;
};

export const authChildGuard: CanActivateChildFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    await authService.waitForAuthInit();
    if (authService.isAuthenticated()) {
      return true;
    }
  } catch (e) {
    // fall through
  }

  router.navigate(['/auth/login']);
  return false;
};
